<ng-container *ngIf="canShowDrawer">
  <div
    class="report-drawer-sidebar"
    [class.report-mode]="isCreateReportMode$ | async"
    [style.marginRight]="hasVisibleScrollBar ? drawerScrollbarMargin : drawerNonReportSize"
    [style.width]="(isCreateReportMode$ | async) ? ((isDrawerExpanded$ | async) ? drawerExpandedSize : drawerCollapsedSize) : drawerNonReportSize"
  >
    <ng-container *ngIf="isDrawerExpanded$ | async; else CollapsedSidebar" [ngTemplateOutlet]="ExpandedSideBar"> </ng-container>
  </div>
</ng-container>

<!-- Sidebar Templates -->
<ng-template #ExpandedSideBar>
  <div class="drawer-expanded">
    <div class="panel-header">
      <div class="toolbar">
        <div class="title">
          <span>{{ DrawerConstants.title | translate }}</span>
        </div>
        <div class="buttonset">
          <button
            soho-button="icon"
            icon="expand-app-tray"
            [attr.data-automation-id]="DrawerConstants.Button.expandId"
            title="{{ DrawerConstants.Button.collapse | translate }}"
            (click)="onExpand(false)"
          ></button>
          <button
            soho-button="icon"
            icon="close-small"
            [attr.data-automation-id]="DrawerConstants.Button.cancelId"
            title="{{ DrawerConstants.Button.cancel | translate }}"
            (click)="onClose()"
          ></button>
        </div>
      </div>
    </div>

    <div class="viewer-container">
      <lm-report-field-picker-viewer *ngIf="isCreateReportMode$ | async"></lm-report-field-picker-viewer>
    </div>

    <div class="row">
      <div class="container">
        <div class="field">
          <button
            [attr.data-automation-id]="DrawerConstants.Button.addToExistingReportId"
            soho-button="secondary"
            title="{{ DrawerConstants.Button.addToExistingReportTitle | translate }}"
            [disabled]="(selectedFields$ | async).size === 0"
            (click)="onAddToExistingReport()"
          >
            {{ DrawerConstants.Button.addToExistingReportLabel | translate }}
          </button>
        </div>
        <div class="field">
          <button
            [attr.data-automation-id]="DrawerConstants.Button.createNewReportId"
            soho-button="primary"
            title="{{ DrawerConstants.Button.createNewReportTitle | translate }}"
            [disabled]="(selectedFields$ | async).size === 0"
            (click)="onCreateNewReport()"
          >
            {{ DrawerConstants.Button.createNewReportLabel | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #CollapsedSidebar>
  <div class="drawer-collapsed">
    <div class="panel-header">
      <div class="buttonset">
        <button
          [attr.data-automation-id]="DrawerConstants.Button.collapseId"
          soho-button="icon"
          icon="collapse-app-tray"
          title="{{ DrawerConstants.Button.expand | translate }}"
          (click)="onExpand(true)"
        ></button>
      </div>

      <div class="title">
        <span
          ><b>{{ DrawerConstants.title | translate }}</b></span
        >
        <ng-container *ngIf="(selectedFields$ | async).size > 0">
          <span class="round success badge" [@bounce]="(selectedFields$ | async).size">{{ (selectedFields$ | async).size }}</span>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
